import { render, staticRenderFns } from "./x-date-picker.vue?vue&type=template&id=37636ea2&scoped=true&"
import script from "./x-date-picker.vue?vue&type=script&lang=js&"
export * from "./x-date-picker.vue?vue&type=script&lang=js&"
import style0 from "./x-date-picker.vue?vue&type=style&index=0&id=37636ea2&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37636ea2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/anatec/wesave/wesave-conseil-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('37636ea2', component.options)
    } else {
      api.reload('37636ea2', component.options)
    }
    module.hot.accept("./x-date-picker.vue?vue&type=template&id=37636ea2&scoped=true&", function () {
      api.rerender('37636ea2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/controls/x-date-picker.vue"
export default component.exports